import type { ConversationSummary } from '@livechat/shared';

export function sortedWaitingChats(conversations: ConversationSummary[]): ConversationSummary[] {
	return conversations
		.filter((conversation) => conversation.status === 'queued')
		.sort((left, right) => {
			const createdDifference =
				new Date(left.queuedAt ?? left.createdAt).getTime() -
				new Date(right.queuedAt ?? right.createdAt).getTime();
			return createdDifference || left.id.localeCompare(right.id);
		});
}

export function waitingDuration(createdAt: string, now = Date.now()): string {
	const startedAt = new Date(createdAt).getTime();
	if (!Number.isFinite(startedAt)) return '—';
	const totalMinutes = Math.max(0, Math.floor((now - startedAt) / 60_000));
	if (totalMinutes < 1) return '< 1 min';
	if (totalMinutes < 60) return `${totalMinutes} min`;
	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;
	return minutes ? `${hours}h ${minutes}m` : `${hours}h`;
}
